import { SVGProps, Ref, forwardRef } from 'react';

export const FrameStarOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m11.312 14.705-.593-1.423-1.424-.594c-.67-.279-1.198-.5-1.615-.688.417-.187.945-.409 1.615-.688l1.424-.593.593-1.424c.28-.67.5-1.198.688-1.615.188.417.409.945.688 1.615l.594 1.424 1.423.593c.67.28 1.198.5 1.615.688-.417.188-.944.409-1.615.688l-1.423.594-.594 1.423c-.279.67-.5 1.198-.688 1.615a68 68 0 0 1-.688-1.615m-2.71-5.054.74-.309.309-.74C10.65 6.202 11.15 5 12 5c.848 0 1.348 1.201 2.349 3.603l.308.74.74.308C17.798 10.65 19 11.15 19 12c0 .848-1.2 1.348-3.603 2.349l-.739.308-.308.74C13.35 17.798 12.849 19 12 19c-.848 0-1.349-1.2-2.35-3.603l-.307-.739-.74-.308C6.2 13.35 5 12.849 5 12c0-.848 1.201-1.349 3.603-2.35"
                fill="currentColor"
            />
            <path
                d="M2.809 16.05c.05.543.112 1.03.195 1.468.246 1.306.617 2 1.048 2.431.43.43 1.125.802 2.431 1.048.438.083.925.145 1.468.195V23C3.005 22.577 1.423 20.995 1 16.05z"
                fill="currentColor"
            />
            <path
                d="M23 16.05c-.422 4.945-2.005 6.527-6.95 6.95v-1.808q.813-.073 1.468-.195c1.306-.246 2-.617 2.431-1.048.431-.43.802-1.125 1.048-2.431q.122-.655.195-1.468z"
                fill="currentColor"
            />
            <path
                d="M16.05 1c4.946.423 6.528 2.006 6.95 6.952h-1.808c-.05-.543-.112-1.03-.195-1.468-.246-1.306-.617-2-1.048-2.431-.43-.43-1.125-.802-2.431-1.048a16 16 0 0 0-1.468-.196z"
                fill="currentColor"
            />
            <path
                d="M7.951 2.809q-.813.073-1.468.196c-1.306.246-2 .617-2.431 1.048-.431.43-.802 1.125-1.048 2.431-.083.438-.145.925-.195 1.468H1C1.423 3.006 3.005 1.422 7.951 1z"
                fill="currentColor"
            />
        </g>
    </svg>
));
FrameStarOutlinedSize24Glyph.displayName = 'FrameStarOutlinedSize24Glyph';
